/**
 * Merges updates into existing public activities URL search params (PERF-06).
 * Preserves params not listed in updates (UTM, hideFilter, viewMode, etc.).
 */
export const mergePublicActivitiesSearchParams = (
  current: URLSearchParams,
  updates: Record<string, string | boolean | undefined>
): URLSearchParams => {
  const next = new URLSearchParams(current)

  for (const [key, value] of Object.entries(updates)) {
    if (value === undefined) continue
    if (typeof value === 'boolean') {
      if (value) {
        next.set(key, 'true')
      } else {
        next.delete(key)
      }
    } else if (value === '') {
      next.delete(key)
    } else {
      next.set(key, value)
    }
  }

  return next
}

export const publicActivitiesSearchParamsFromState = (state: {
  filterText: string
  groupBy: string
  cityName: string
  danceStyle: string
  activityType: string
  groupSorting: string
  viewMode: string
  hideFilter: boolean
  period: string
  periodId: string
  showSubEvents: boolean
  showParentEvent: boolean
  disableMonthGrouping: boolean
  lang?: string | null
}): Record<string, string | boolean | undefined> => ({
  filter: state.filterText || undefined,
  group: state.groupBy,
  cityName: state.cityName || undefined,
  danceStyle: state.danceStyle || undefined,
  activityType: state.activityType || undefined,
  groupSorting: state.groupSorting,
  viewMode: state.viewMode,
  hideFilter: state.hideFilter,
  period: state.period || undefined,
  periodId: state.periodId || undefined,
  showSubEvents: state.showSubEvents,
  showParentEvent: state.showParentEvent,
  disableMonthGrouping: state.disableMonthGrouping,
  lang: state.lang || undefined
})
